<template>
  <div class="customer-support">
    <img
      @click="close"
      class="close"
      src="../../assets/images/modals/close.png"
      alt="close"
    />
    <h2>CUSTOMER SUPPORT</h2>
    <p>Have a question or need help?</p>
    <p>Send us a message. We often respond within 2 hours.</p>
    <div class="submitted" v-if="submitted">
      <img
        class="check"
        src="../../assets/images/modals/check.jpg"
        alt="confirm"
      />
      <h3>Thanks for contacting us!</h3>
      <p>
        We've received your message and a support agent will be contacting you
        within 24 hours.
      </p>
      <p>Thanks for choosing ProGuides!</p>
    </div>
    <form @submit="submit" v-else>
      <div class="select-container">
        <img
          class="arrow-down"
          src="../../assets/images/modals/down.svg"
          alt="arrow down"
        />
        <select ref="subject" v-model="subject" @input="onChange">
          <option value="">Select a Support Category</option>
          <option value="Bug">Report Bug</option>
          <option value="Membership/Payments">Membership/Payments</option>
          <option value="Coaching">Coaching</option>
          <option value="Other">Other</option>
        </select>
      </div>
      <input
        ref="name"
        v-model="name"
        type="text"
        placeholder="Name"
        @input="onChange"
      />
      <input
        ref="email"
        v-model="email"
        type="email"
        placeholder="Email address"
        @input="onChange"
      />
      <textarea
        ref="message"
        v-model="message"
        rows="4"
        placeholder="Message"
        @input="onChange"
      ></textarea>
      <ul class="errors" v-if="errors.length">
        <li v-for="error in errors" :key="error">{{ error }}</li>
      </ul>
      <button :class="{ loading: loading }" :disabled="loading">
        <lottie
          v-if="loading"
          :options="{ animationData: loadingAnim }"
          :width="24"
          :height="24"
        />
        <span v-else>Submit</span>
      </button>
    </form>
    <div class="chat-section">
      <img
        @click="startHelpChat"
        src="../../assets/images/modals/chat-help.svg"
        alt="chat"
      />
      <div>
        <h3>Need help sooner?</h3>
        <p>
          Chat live with a ProGuides Associate
          <span @click="startHelpChat">Click here!</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/api/axiosAuthRequired.js"
import { mapMutations, mapActions } from "vuex"
import Lottie from "vue-lottie"
import loadingAnim from "../../assets/animations/home/authLoading.json"

export default {
  components: {
    Lottie,
  },
  data: function () {
    return {
      subject: "",
      name: "",
      email: "",
      message: "",
      errors: [],
      loading: false,
      loadingAnim,
      submitted: false,
    }
  },
  methods: {
    ...mapMutations("Modals", ["setShowingModal"]),
    ...mapActions("Util", ["startHelpChat"]),
    close () {
      this.setShowingModal("")
    },
    onChange (e) {
      if (e.target.value) {
        e.target.classList.remove("error")
      }
    },
    async submit (e) {
      e.preventDefault()
      this.resetForm()
      if (!this.subject) {
        this.errors.push("Please select a subject")
        this.$refs.subject.classList.add("error")
      }
      if (!this.name) {
        this.errors.push("Name must have a value")
        this.$refs.name.classList.add("error")
      }
      if (!this.email) {
        this.errors.push("Email address must be a valid e-mail")
        this.$refs.email.classList.add("error")
      }
      if (!this.message) {
        this.errors.push("Message must have a value")
        this.$refs.message.classList.add("error")
      }
      if (this.errors.length) {
        return
      }
      this.loading = true
      const url = "/functions/contact-us.php"
      const { subject, name, email, message } = this
      // const data = {
      //   subject,
      //   name,
      //   email,
      //   message,
      // }
      const params = new URLSearchParams()
      params.append("subject", subject)
      params.append("name", name)
      params.append("email", email)
      params.append("message", message)
      const config = {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      }
      try {
        await axios.post(url, params, config)
        this.loading = false
        this.submitted = true
      } catch (error) {
        this.errors.push(error.response)
        this.loading = false
      }
    },
    resetForm () {
      this.errors = []
      this.$refs.subject.classList.remove("error")
      this.$refs.name.classList.remove("error")
      this.$refs.email.classList.remove("error")
      this.$refs.message.classList.remove("error")
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/style/_mixins.scss";
.customer-support {
  padding: 2rem 0;
  width: 56rem;
  max-width: calc(100% - 4rem);
  background: #fff;
  position: relative;
  .close {
    position: absolute;
    top: 1rem;
    right: 1rem;
    width: 1.5rem;
    height: 1.5rem;
    cursor: pointer;
    transition: all 0.2s;
    &:hover {
      filter: brightness(50%);
    }
  }
  h2 {
    font-family: Proxima Nova;
    font-size: 1.6rem;
    font-weight: 700;
    letter-spacing: 0.13em;
    line-height: 2rem;
    margin: 2rem 0;
    text-align: center;
  }
  p {
    font-family: Proxima Nova;
    font-size: 1.5rem;
    letter-spacing: 0.05em;
    margin: 0;
    text-align: center;
  }
  .submitted {
    padding: 2.7rem 0 4.6rem;
    margin: 0 8rem;
    border-top: 1px solid #e5e5e5;
    margin-top: 1.8rem;
    .check {
      display: block;
      margin: 0 auto 2.3rem;
    }
    h3 {
      font-family: Proxima Nova;
      font-size: 1.5rem;
      font-weight: 800;
      letter-spacing: 0.05em;
      margin: 2rem 0rem;
      text-align: center;
      text-transform: uppercase;
    }
    p {
      font-family: Proxima Nova;
      font-size: 1.5rem;
    }
  }
  form {
    padding: 2rem 0 2rem;
    margin: 0 8rem;
    font-family: Proxima Nova;
    border-top: 1px solid #e5e5e5;
    margin-top: 1rem;
    select,
    input,
    textarea {
      font-family: Proxima Nova;
      width: 100%;
      padding: 1.2rem 2rem;
      margin: 0.6rem 0;
      outline: none;
      font-size: 1.6rem;
      overflow: none;
      border: 1px solid rgba(34, 36, 38, 0.15);
      border-radius: 4px;
      background: #f9f9f9;
      color: #3b3b3b;
      &::placeholder {
        color: #b4b4b5;
      }
      &:focus::placeholder {
        color: #a3a3a3;
      }
      &.error {
        border-color: #e0b4b4;
        background-color: #fff6f6;
        color: #9f3a38;
      }
    }
    .select-container {
      position: relative;
      .arrow-down {
        position: absolute;
        z-index: 2;
        right: 1rem;
        top: 50%;
        transform: translateY(-50%);
      }
      select {
        cursor: pointer;
        appearance: none;
      }
    }
    textarea {
      resize: none;
    }
    button {
      font-family: Proxima Nova;
      background-color: #019aff;
      height: 5rem;
      width: 22.2rem;
      font-size: 1.6rem;
      border-radius: 4px;
      outline: none;
      border: none;
      color: #fff;
      margin: 1rem auto 0.8rem;
      cursor: pointer;
      &.loading {
        opacity: 0.7;
      }
    }
    .errors {
      font-size: 1.1rem;
      text-align: left;
      background-color: #fff6f6;
      color: #9f3a38;
      padding: 1rem 2.5rem;
      border-radius: 0.28571429rem;
      border: 1px solid #e0b4b4;
    }
  }
  .chat-section {
    border-top: 1px solid #e5e5e5;
    display: flex;
    padding: 2rem 8rem;
    text-align: left;
    background: #f9f9f9;
    img {
      margin-right: 1rem;
      cursor: pointer;
    }
    h3 {
      font-family: Proxima Nova;
      font-size: 1.8rem;
      margin: 0;
      font-weight: 700;
    }
    p {
      font-family: Proxima Nova;
      font-size: 1.5rem;
      margin: 0;
    }
    span {
      font-family: Proxima Nova;
      font-size: 1.5rem;
      font-weight: 700;
      text-decoration: underline;
      color: #019aff;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modals/CustomerSupport.vue